import { Component } from '@theme/component';
import { StandardEvents, CartLinesUpdateEvent } from '@shopify/events';
import { DrawerOpenEvent, DrawerCloseEvent } from '@theme/theme-drawer';

class HeaderActions extends Component {
  requiredRefs = ['liveRegion'];

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(StandardEvents.cartLinesUpdate, this.#onCartUpdate);
    document.addEventListener(DrawerOpenEvent.eventName, this.#onDrawerStateChange);
    document.addEventListener(DrawerCloseEvent.eventName, this.#onDrawerStateChange);
    this.#syncCartTriggerAriaExpanded();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.#onCartUpdate);
    document.removeEventListener(DrawerOpenEvent.eventName, this.#onDrawerStateChange);
    document.removeEventListener(DrawerCloseEvent.eventName, this.#onDrawerStateChange);
  }

  #syncCartTriggerAriaExpanded = () => {
    const cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer) return;
    const trigger = this.querySelector('[aria-controls="cart-drawer"]');
    if (!trigger) return;
    trigger.setAttribute('aria-expanded', cartDrawer.hasAttribute('open') ? 'true' : 'false');
  };

  #onDrawerStateChange = (event) => {
    const target = /** @type {HTMLElement | null} */ (event.target);
    if (target?.id !== 'cart-drawer') return;
    this.#syncCartTriggerAriaExpanded();
  };

  #onCartUpdate = (event) => {
    event.promise
      ?.then(({ cart }) => {
        const cartCount = cart?.totalQuantity;
        if (cartCount === undefined) return;
        this.refs.liveRegion.textContent = `${Theme.translations.cart_count}: ${cartCount}`;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[header-actions] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('header-actions')) {
  customElements.define('header-actions', HeaderActions);
}

// Redirigir a Mi Cuenta Yaxmuul después del login
(function () {
  var YAX_REDIRECT = '/pages/yaxmuul-points';
  var YAX_KEY = 'yax_redirect_after_login';
  var isLoggedIn = document.body.dataset.customerLoggedIn === 'true';

  if (!isLoggedIn) {
    // Guardar flag y arrancar watcher
    sessionStorage.setItem(YAX_KEY, '1');

    var interval = setInterval(function () {
      fetch('/account.json', { credentials: 'same-origin' })
        .then(function (r) {
          if (r.ok) {
            var flag = sessionStorage.getItem(YAX_KEY);
            if (flag) {
              sessionStorage.removeItem(YAX_KEY);
              clearInterval(interval);
              window.location.href = YAX_REDIRECT;
            }
          }
        })
        .catch(function () {});
    }, 800);

    // Detener el watcher si el usuario navega sin loguearse (max 5 min)
    setTimeout(function () { clearInterval(interval); }, 300000);
  }
})();
